import styled, { DefaultTheme } from 'styled-components';

interface IProps {
  variant: keyof DefaultTheme['statusTag'];
  isFlex?: boolean;
  maxWidth?: string;
  demandArchived?: boolean;
}

export const StatusTag = styled.div<IProps>`
  background-color: ${({ theme, variant, demandArchived }) =>
    demandArchived ? theme.colors.gray700 : theme.statusTag[variant].background};
  color: ${({ theme, variant }) => theme.statusTagBugetControl[variant].color};
  font-size: 0.85rem;
  border-radius: 1rem;
  font-weight: 600;
  padding: 0.35rem 1rem;
  text-align: center;
  width: 100%;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  ${({ isFlex }) => (isFlex ? 'display: flex;' : '')}
  span.tooltip {
    margin-left: 8px;
  }
  ${({ maxWidth }) => (maxWidth ? `max-width: ${maxWidth}` : '')}
`;

interface IBudgetProps {
  variant: keyof DefaultTheme['statusTagBugetControl'];
  isFlex?: boolean;
  maxWidth?: string;
}

export const StatusTagBudgetControl = styled.div<IBudgetProps>`
  background-color: ${({ theme, variant }) => theme.statusTagBugetControl[variant].background};
  color: ${({ theme, variant }) => theme.statusTagBugetControl[variant].color};
  border-radius: 2rem;
  padding: 0.5rem 0.3rem;
  font-weight: 700;
  font-size: 0.88rem;
  text-align: center;
  width: 8rem;
  display: flex;
  justify-content: center;
  /* padding: 0px 16px; */

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  ${({ isFlex }) => (isFlex ? 'display: flex;' : '')}
  span.tooltip {
    margin-left: 8px;
  }
  ${({ maxWidth }) => (maxWidth ? `max-width: ${maxWidth}` : '')}
`;
